export const dataModuleName = {
  type: 'string',
};
